import { ThunkAction } from 'redux-thunk'

import config from 'admin/config/main'
import { reduxDependenciesType } from 'admin/redux/create'
import { State } from 'admin/redux/ducks'
import {
  PaymentPurchaserType,
  PaymentPurchaserStatus,
  PurchaserPersonMapType,
  PurchaserPersonType,
} from 'admin/types'
import createApiReducer, {
  requestDataFor,
  receiveDataFor,
  handleErrorFor,
} from 'redux/utils/createApiDuck'
import { ErrorType, APIState } from 'types'

const moduleName = `${config.appName}/purchasers`

export default createApiReducer(moduleName)

export function isPurchaser(
  data: PaymentPurchaserType[] | ErrorType
): data is PaymentPurchaserType[] {
  return data && (data as PaymentPurchaserType[]).length !== undefined
}

/**
 * Get purchaser list and rearrange it into a list of people with their purchaser roles listed
 */
export function fetchPurchaserPersonList(
  orgAccountId: string,
  status:
    | PaymentPurchaserStatus
    | PaymentPurchaserStatus[] = PaymentPurchaserStatus.ACTIVE
): ThunkAction<Promise<any>, State, reduxDependenciesType> {
  return (dispatch, getState, { api }) => {
    dispatch(requestDataFor(moduleName)())
    return api
      .getPaymentPurchasersList(orgAccountId, status)
      .then((purchasers) => {
        const personPurchaserData: PurchaserPersonMapType = {}
        if (isPurchaser(purchasers)) {
          purchasers.forEach((purchaser: PaymentPurchaserType) => {
            // Add purchaser to existing person
            if (personPurchaserData[purchaser.purchaserKimId]) {
              personPurchaserData[
                purchaser.purchaserKimId
              ].invoiceRecipients.push({
                purchaserId: purchaser.purchaserId,
                invoiceRecipientId: purchaser.invoiceRecipientId,
                invoiceRecipientName: purchaser.invoiceRecipientName,
                purchaseLimit: purchaser.purchaseLimit,
                status: purchaser.status,
              })
              // Set up new person with
            } else {
              return Object.assign(personPurchaserData, {
                [purchaser.purchaserKimId]: {
                  purchaserKimId: purchaser.purchaserKimId,
                  purchaserFirstName: purchaser.purchaserFirstName,
                  purchaserLastName: purchaser.purchaserLastName,
                  purchaserPersonalId: purchaser.purchaserPersonalId,
                  invoiceRecipients: [
                    {
                      purchaserId: purchaser.purchaserId,
                      invoiceRecipientId: purchaser.invoiceRecipientId,
                      invoiceRecipientName: purchaser.invoiceRecipientName,
                      purchaseLimit: purchaser.purchaseLimit,
                      status: purchaser.status,
                    },
                  ],
                },
              })
            }
          })
        }
        dispatch(receiveDataFor(moduleName)(Object.values(personPurchaserData)))
        return personPurchaserData
      })
      .catch((error) => dispatch(handleErrorFor(moduleName)(error)))
  }
}

export function getPaymentPurchasersExcel(
  orgKimId: number
): ThunkAction<Promise<any>, State, reduxDependenciesType> {
  return (_dispatch, _getState, { api }) => {
    return api.getPaymentPurchasersExcel(orgKimId)
  }
}

export interface PurchasersState extends APIState {
  data: PurchaserPersonType[]
}
